/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
/*global console */

expocadfx.Login = function( type) {
	'use strict';
    var CompanyList = expocadfx.CompanyList;
    var data = expocadfx.fxData;
    var txt = expocadfx.txt;
    var FxEvent = expocadfx.fxevent;
      
    var doc = document;
    var divId = null;
    var nodes = null;
    var divLogin = null;
    var divContent = null;
    var divPswd = null;
    var lblPswd = null;
    var txtPswd = null;
    var txtId = null;
    var divButtons = null;
    var btnLogin = null;
    var btnCancel = null;
    var divCompanies = null;
    var prompt = null;
    var logoDiv = null;
    var logo = null;
    var selectedCompanyId = "";
    var companyList = null;
    var loginType = type;
    var newFooter;
    
    
    function cancelHandler() {
        doc.dispatchEvent( new FxEvent( "Cancel_Login", {}));
    }
    
    function loginClickHandler() {
        if( txtPswd.value !== "" && ( type === "none" || txtId.value !== "")) {
           var obj = {
                "password" : txtPswd.value,
                "user" : "",
                "selected" : selectedCompanyId
            };
            
           if( txtId !== null) {
               obj.user = txtId.value;
           }
            if( loginType === "sales" && data.salesIniUser !== undefined && data.salesIniPswd !== "") {
                obj.user = data.salesIniUser;
                obj.password = data.salesIniPswd;
                prompt.classList.add('wrongLogin');
            }
            
            btnLogin.disabled = true;
            if( loginType !== "none") {
                prompt.textContent = txt.CONNECTING + txt.SALES_SERVER;
                if(prompt.classList.contains('wrongLogin')){
                    prompt.classList.remove('wrongLogin');
                }
            }
            doc.dispatchEvent( new FxEvent( "Submit_Login", obj));
        }
        else if( type === "none") {
            prompt.textContent = txt.REQUIRED_PASSWORD;
            prompt.classList.add('wrongLogin');
        }
        else if( type === "Exhibitor") {
            prompt.textContent = txt.REQUIRED_COMPANY_PASSWORD;
            prompt.classList.add('wrongLogin');

        }
        else {
            prompt.textContent = txt.REQUIRED_ID_PASSWORD;
            prompt.classList.add('wrongLogin');

        }
    }
    
    function keyboardHandler(evt) {
        if( evt.key === "Enter") {
            loginClickHandler();
        }
    }
    
    function loginSucceeded() {
        btnLogin.removeEventListener( "click", loginClickHandler, false);
        doc.removeEventListener( "keyup", keyboardHandler);
        if( btnCancel) {
            btnCancel.removeEventListener( "click", cancelHandler);
        }
        btnLogin.disabled = false;
    }
    
    function loginFailed( msg) {
        btnLogin.disabled = false;
        if( loginType !== "none") {
            prompt.textContent = msg;
            prompt.classList.add('wrongLogin');
        }
        //prompt.style.color = "#ff0000";
        txtPswd.value = "";
        if( txtId !== null) {
            txtId.value = "";
        }
    }
    
    function getCompany() {
        return {
            companyName: txtId.value,
            companyId: selectedCompanyId
        };
    }
    
    function gridClickHandler( evt) {
        selectedCompanyId = evt.data.companyId;
        txtId.value = evt.data.companyName;
    }
    
//    function resetLogin() {
//        if( txtId !== null) {
//            txtId.value = "";
//        }
//        txtPswd.value = "";
//        selectedCompanyId = "";
//        prompt.textContent = msg;
//        prompt.style.color = "#000000";
//        //  clear company list ??
//    }
    
    function initLogin() {
        if( txtId !== null) {
            txtId.value = "";
        }
        txtPswd.value = "";
        selectedCompanyId = "";
        if( loginType === "none") {
            prompt.textContent = txt.ENTER_PASSWORD;
        }
        else if( type === "Exhibitor") {
            prompt.textContent = txt.SELECT_COMPANY_PASSWORD;
        }
        else {
            prompt.textContent = txt.ENTER_ID_PASSWORD;
        }
        
        prompt.style.color = "#000000";
        if( loginType === "sales" && data.salesIniUser !== undefined && data.salesIniPswd !== "") {
            txtId.value = "Demo User";
            txtPswd.value = "xxxxxxxxxx";
        }
        
        btnLogin.disabled = false;
        btnLogin.addEventListener( "click", loginClickHandler);
        doc.addEventListener( "keyup", keyboardHandler);
        if( btnCancel) {
            btnCancel.addEventListener( "click", cancelHandler);
        }
    }
    
    /////////////////////////   Main  //////////////////////////////////////
    
    divLogin = doc.createElement("div");
    divLogin.setAttribute( "id", "login_div");
    divContent = doc.createElement("div");
    divPswd = doc.createElement( "div");
    lblPswd = doc.createElement( "label");
    txtPswd = doc.createElement( "input");
    logo = doc.createElement('img');
    logoDiv = doc.createElement('div');
    logo.setAttribute('src', 'https://i.imgur.com/A1IeL2U.png')
    prompt = doc.createElement("p");
    prompt.setAttribute('id', 'loginP')
    newFooter = doc.createElement('div');
    newFooter.setAttribute('id', 'newFooter');

    
    divLogin.setAttribute( "class", "modalDialog");
    divContent.setAttribute( "class", "login");
    divLogin.appendChild(newFooter);
    newFooter.textContent = "EXPOCAD® FX" + txt.COPYRIGHT + " " + txt.VERSION + data.version;
    
        // if exhibitor login - add grid with exhibitors (and search box)
    if( type === "Exhibitor") {
        divCompanies = doc.createElement( "div");
        divContent.appendChild( divCompanies);
        var h =  0.6 * doc.body.clientHeight + "px";
        divCompanies.style.height = h;
        prompt.setAttribute( "class", "loginPrompt");
        companyList = new CompanyList( divCompanies);
        doc.addEventListener( "Company_Grid_Click", gridClickHandler);
    }
        //  all types need prompt and password input
    divContent.appendChild( logoDiv);
    logoDiv.appendChild( logo);
    divContent.appendChild( prompt);
    divPswd.appendChild( lblPswd);
    divPswd.appendChild( txtPswd);
    
    if( type !== "none") {
        divId = divPswd.cloneNode( true);
        nodes = divId.getElementsByTagName( "label");
        nodes[0].textContent = txt.USER_ID;
        
        txtId = divId.getElementsByTagName( "input")[0];
        txtId.setAttribute( "id", "txtId");
		txtId.setAttribute( "type", "text");
		txtId.setAttribute( "autofocus", "true");
        
        divContent.appendChild( divId);
    }
        // add password field
    lblPswd.textContent = txt.PASSWORD;
    txtPswd.setAttribute( "id", "txtPassword");
    txtPswd.type = "password";
    divContent.appendChild( divPswd);
    
    divButtons = doc.createElement( "div");
    
    btnLogin = doc.createElement( "button");
    btnLogin.textContent = txt.LOGIN;
    
    
    divButtons.appendChild( btnLogin);
    
    if( type !== "none") {
        btnCancel = doc.createElement( "button");
        btnCancel.textContent = txt.CANCEL;

        divButtons.appendChild( btnCancel);
        
    }
    divContent.appendChild( divButtons);
    divLogin.appendChild( divContent);
    
    
    return {
        getConpanyInfo: getCompany,
        getLoginDiv: function() {
            return divLogin;
        },
        initLogin: initLogin,
        loginFailed: loginFailed,
        loginSucceeded: loginSucceeded,
        setCompanies: function( value) {
            if( companyList !== null) {
                companyList.setCompanies( value, divCompanies);
            }
            else {
                console.log( "COMPANY LIST IS NULL");
            }
        }
    };
};